import * as React from "react";
import { Alert, Button } from "antd";
import { store } from "../../../../store";
import { cloneDeep, get } from "lodash";
import { firewallRequirementsForVolumes } from "../../../../schema/types/workload/entity";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { v4 as uuidv4 } from "uuid";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

interface Props {}
export const OutboundFirewallRecommendationsPortAllowList: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  // TODO can also add a suggestion section to validator and move this there

  const containers = useCpFormValue(`containers`);
  const isPublic = useCpFormValue(`firewallConfig.external.outbound.public`);
  const hostnames = useCpFormValue(`firewallConfig.external.outbound.allowHostname`);
  const ports = useCpFormValue(`firewallConfig.external.outbound.allowPort`);

  const firewallRecommendations: string[] = React.useMemo(() => {
    const form = store.getState().form.instances[id];
    const values = form.values;

    const firewallRecommendations: string[] = [];

    const isPublic = get(values, `firewallConfig.external.outbound.public`);
    const hostnames = get(values, `firewallConfig.external.outbound.allowHostname`);

    if (isPublic) {
      return firewallRecommendations;
    }

    for (const container of containers) {
      const volumes = container.volumes;
      for (const volume of volumes) {
        if (!volume) {
          continue;
        }
        for (const prefix of Object.keys(firewallRequirementsForVolumes)) {
          if (volume.uriType !== prefix) {
            continue;
          }

          const value: string[] = firewallRequirementsForVolumes[prefix];
          for (const recommendation of value) {
            if (
              !firewallRecommendations.includes(recommendation) &&
              !hostnames.some((h) => h.value === recommendation)
            ) {
              firewallRecommendations.push(recommendation);
            }
          }
        }
      }
    }

    return firewallRecommendations;
  }, [containers, isPublic, hostnames]);

  if (firewallRecommendations.length < 1) {
    return null;
  }

  return (
    <>
      {!isPublic && hostnames.length > 0 ? (
        <Alert
          message={`Workloads cannot reach to workloads in remote GVCs because this requires port 15443 to be allowed. However, when using a hostname allowlist, only ports 80, 443, and 445 are permitted for outbound traffic.`}
          type={`warning`}
          className="mb-2"
        />
      ) : isPublic && ports.length > 0 && !ports.some((p) => p.number.value === "15443") ? (
        <Alert
          className="mb-2"
          message={
            <div>
              <div className="mb-2">
                Workloads cannot reach to workloads in remote GVCs unless outbound traffic on port 15443 is allowed.
              </div>
              <Button
                className="mt-2"
                size={"small"}
                type={"primary"}
                onClick={() => {
                  const form = store.getState().form.instances[id];
                  const values = form.values;
                  const ports = get(values, `firewallConfig.external.outbound.allowPort`);
                  const _ports = cloneDeep(ports);
                  _ports.push({ id: uuidv4(), protocol: "tcp", number: "15443" });
                  formSetValue(id, `firewallConfig.external.outbound.allowPort`, _ports);
                }}
              >
                Allow All Outbound Access
              </Button>
            </div>
          }
          type={`warning`}
        />
      ) : !isPublic ? (
        <Alert
          className="mb-2"
          message={
            <div>
              <div className="mb-2">
                Workloads cannot reach to workloads in remote GVCs unless outbound traffic on port 15443 is allowed.
              </div>
              <Button
                className="mt-2"
                size={"small"}
                type={"primary"}
                onClick={() => {
                  const form = store.getState().form.instances[id];
                  const values = form.values;
                  const ports = get(values, `firewallConfig.external.outbound.allowPort`);
                  const _ports = cloneDeep(ports);
                  _ports.push({ id: uuidv4(), protocol: "tcp", number: "15443" });
                  formSetValue(id, `firewallConfig.external.outbound.allowPort`, _ports);
                  formSetValue(id, `firewallConfig.external.outbound.public`, true);
                }}
              >
                Allow All Outbound Access
              </Button>
            </div>
          }
          type={`warning`}
        />
      ) : null}
    </>
  );
};
